export default function ComparisonTable() {
  const comparisonData = [
    {
      rank: 1,
      name: '三井住友カード（NL）',
      basicRate: '0.5%',
      specialRate: '最大7%',
      specialStores: 'セブン-イレブン、ローソン、マクドナルドなど',
      annualFee: '永年無料',
      detailUrl: '/mitsui'
    },
    {
      rank: 2,
      name: 'リクルートカード',
      basicRate: '1.2%',
      specialRate: '最大4.2%',
      specialStores: 'じゃらん、ホットペッパービューティー',
      annualFee: '永年無料',
      detailUrl: '/recruit'
    },
    {
      rank: 3,
      name: '大手ECモール系カード',
      basicRate: '1.0%',
      specialRate: '最大3%',
      specialStores: 'ECモール、トラベル',
      annualFee: '永年無料',
      detailUrl: '/rakuten'
    },
    {
      rank: 4,
      name: '国際ブランド系カード W',
      basicRate: '1.0%',
      specialRate: '最大5.5%',
      specialStores: 'Amazon、スターバックス',
      annualFee: '永年無料',
      detailUrl: '/jcbw'
    },
    {
      rank: 5,
      name: 'dカード',
      basicRate: '1.0%',
      specialRate: '最大4.5%',
      specialStores: 'd払い加盟店、マツモトキヨシ',
      annualFee: '永年無料',
      detailUrl: '/dcard'
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4">
        <h3 className="text-3xl font-bold text-center mb-4 text-[#003366]">
          還元率詳細比較一覧表
        </h3>
        <p className="text-center text-gray-600 mb-12">
          基本還元率と特約店での還元率を比較して、自分に合ったカードを見つけましょう
        </p>

        {/* Desktop Table */}
        <div className="hidden md:block overflow-x-auto bg-white rounded-xl shadow-lg">
          <table className="w-full">
            <thead>
              <tr className="bg-[#003366] text-white">
                <th className="py-4 px-4 text-left font-bold">順位</th>
                <th className="py-4 px-4 text-left font-bold">カード名</th>
                <th className="py-4 px-4 text-left font-bold">基本還元率</th>
                <th className="py-4 px-4 text-left font-bold">特約店還元率</th>
                <th className="py-4 px-4 text-left font-bold">主な特約店</th>
                <th className="py-4 px-4 text-left font-bold">年会費</th>
                <th className="py-4 px-4 text-center font-bold">詳細</th>
              </tr>
            </thead>
            <tbody>
              {comparisonData.map((card, index) => (
                <tr
                  key={card.rank}
                  className={`border-b border-gray-200 hover:bg-gray-50 transition-colors ${
                    index === 0 ? 'bg-yellow-50' : ''
                  }`}
                >
                  <td className="py-4 px-4">
                    <div className="flex items-center gap-2">
                      <span className="text-2xl font-bold text-[#FFB800]">{card.rank}</span>
                      {index === 0 && (
                        <span className="bg-[#FFB800] text-white text-xs px-2 py-1 rounded-full font-bold whitespace-nowrap">
                          おすすめ
                        </span>
                      )}
                    </div>
                  </td>
                  <td className="py-4 px-4 font-bold text-[#003366]">{card.name}</td>
                  <td className="py-4 px-4 text-lg font-bold text-[#14B8A6]">{card.basicRate}</td>
                  <td className="py-4 px-4 text-lg font-bold text-[#FFB800]">{card.specialRate}</td>
                  <td className="py-4 px-4 text-sm text-gray-700">{card.specialStores}</td>
                  <td className="py-4 px-4 font-bold text-[#14B8A6]">{card.annualFee}</td>
                  <td className="py-4 px-4 text-center">
                    <a
                      href={card.detailUrl}
                      className="inline-block bg-[#003366] text-white px-4 py-2 rounded-lg text-sm font-bold hover:bg-[#004488] transition-all cursor-pointer whitespace-nowrap"
                    >
                      詳細を見る
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Mobile Cards */}
        <div className="md:hidden space-y-4">
          {comparisonData.map((card, index) => (
            <div
              key={card.rank}
              className={`bg-white rounded-xl p-6 shadow-lg ${
                index === 0 ? 'border-2 border-[#FFB800]' : ''
              }`}
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 bg-gradient-to-br from-[#FFB800] to-[#FFA000] rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-white text-xl font-bold">{card.rank}</span>
                </div>
                <h4 className="text-lg font-bold text-[#003366]">{card.name}</h4>
                {index === 0 && (
                  <span className="bg-[#FFB800] text-white text-xs px-2 py-1 rounded-full font-bold whitespace-nowrap">
                    おすすめ
                  </span>
                )}
              </div>

              <div className="space-y-3 mb-4">
                <div className="flex justify-between items-center">
                  <span className="text-sm text-gray-600">基本還元率</span>
                  <span className="text-lg font-bold text-[#14B8A6]">{card.basicRate}</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-sm text-gray-600">特約店還元率</span>
                  <span className="text-lg font-bold text-[#FFB800]">{card.specialRate}</span>
                </div>
                <div>
                  <div className="text-sm text-gray-600 mb-1">主な特約店</div>
                  <div className="text-sm text-gray-700">{card.specialStores}</div>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-sm text-gray-600">年会費</span>
                  <span className="font-bold text-[#14B8A6]">{card.annualFee}</span>
                </div>
              </div>

              <a
                href={card.detailUrl}
                className="block w-full bg-[#003366] text-white px-4 py-3 rounded-lg font-bold text-center hover:bg-[#004488] transition-all cursor-pointer whitespace-nowrap"
              >
                詳細を見る
              </a>
            </div>
          ))}
        </div>

        <div className="mt-8 text-center text-sm text-gray-600">
          ※還元率は利用条件により変動します。最新情報は各公式サイトをご確認ください。
        </div>
      </div>
    </section>
  );
}
